import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import * as R from 'ramda'
import { DateUtils, Utils } from '@pbt/pbt-ui-components'
import ResponsibilityName from '@pbt/pbt-ui-components/src/constants/responsibilityNames'

import DialogNames from '~/constants/DialogNames'
import {
  getAppointmentId,
  getClientId,
  getPatientId,
} from '~/store/reducers/soap'
import { getTimetableEvent } from '~/store/reducers/timetable'
import useDialog from '~/utils/useDialog'

import AppointmentDetails from '../../appointment/AppointmentDetails'
import AppointmentStatusSelect from '../../appointment/AppointmentStatusSelect'

import '@chewy/kib-tag-styles/dist/kib-tag.css'
import '@chewy/kib-fields-new-styles/dist/styles/kib-field.css'
import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './SoapAppointmentDetailsHeader.module.scss'

export const SoapAppointmentDetailsHeader = () => {
  const { t } = useTranslation(['Common'])
  const appointmentId = useSelector(getAppointmentId)
  const appointment = useSelector(getTimetableEvent(appointmentId))
  const clientId = useSelector(getClientId)
  const patientId = useSelector(getPatientId)

  const [openAppointmentDialog] = useDialog(DialogNames.EVENT)

  const appointmentTypeName = appointment?.type?.name
  const personResponsibilities = appointment?.personResponsibilities || []

  const vet = personResponsibilities.find(
    R.pathEq(['responsibility', 'name'], ResponsibilityName.Veterinarian),
  )?.person
  const assignedVet = vet
    ? Utils.getPersonString(vet)
    : Utils.getPersonString(
        R.path([0, 'person'], appointment?.personResponsibilities),
      )

  const startDate = DateUtils.formatDate(appointment?.scheduledStartDatetime)

  const startTime = DateUtils.formatTime(
    appointment?.scheduledStartDatetime || '',
  )

  return (
    <div className={styles.container}>
      <div className={styles.appointmentInfoContainer}>
        <AppointmentDetails
          appointmentTypeName={appointmentTypeName}
          assignedVet={assignedVet}
          editButtonLabel={t(
            'TimeTable:ADD_APPOINTMENT_COMPONENT.EDIT_APPOINTMENT',
          )}
          startDate={startDate}
          startTime={startTime}
          onEditClick={() =>
            openAppointmentDialog({
              clientId,
              appointmentId,
              patientId,
            })
          }
        />
        <div className={styles.statusSelectWrapper}>
          <AppointmentStatusSelect />
        </div>
      </div>
    </div>
  )
}
